import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormType } from 'src/app/common/enumerations/enumerations';
import { FormViewState } from 'src/app/common/models/form-view-state';

@Component({
  selector: 'form-history-forms',
  templateUrl: './form-history-forms.component.html',
  styleUrls: ['./form-history-forms.component.scss']
})
export class FormHistoryFormsComponent implements OnChanges {
  @Input() type?: FormType;
  @Input() originalBody: any;
  @Input() form?: any;
  @Input() update: any;

  status?: FormViewState;
  formType = FormType;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.update) {
      this.status = { isViewingAmendment: true, isLogView: true } as FormViewState;
    }
    else this.status = { isViewingAmendment: false, isLogView: true } as FormViewState;
  }

}
